import React, { useState } from 'react';
import InsuranceCompanyModal from '../InsuranceCompany/InsuranceCompanyModal';
import NZCIListItem from '../../../Base/NZCIListItem';
import { InsuranceCompanyValues } from '../InsuranceCompany/InsuranceCompany';
import { TermItem } from '../../../../../../graphql/graphql';
import { InsuranceSettings } from '../../../../Interfaces/insuranceSettings';
import useTranslation from '../../../../../../Hooks/useTranslation';

interface Props {
  key: number|string;
  insuranceCompany: TermItem;
  settings: InsuranceSettings | null;
  saveInsuranceSettings: (values: InsuranceCompanyValues) => void;
}

const InsuranceRow: React.FC<Props> = props => {
  const {insuranceCompany, settings, saveInsuranceSettings} = props;
  const [isSetupOpen, setIsSetupOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  const handleSaveInsuranceSettings = (values: InsuranceCompanyValues) => {
    saveInsuranceSettings(values);
    setIsSetupOpen(false);
  }

  const texts = [
    t('base.shared.identificationNumberLabel') + ':',
    (settings?.companyIdentificationNumber ?? '-') + ',',
    t('base.user') + ':',
    (settings?.username ?? '-')
  ];

  return (
    <div>
      <NZCIListItem
        title={insuranceCompany.value2 || ''}
        value={settings?.companyIdentificationNumber ? texts.join(' ') : 'Nenastaveno'}
        button={{
          title: 'component.nczi.setup.startSetup',
          onClick: () => setIsSetupOpen(true),
        }}
        icon={settings?.companyIdentificationNumber ? '/dist/icons/v2/check-green.svg' : '/dist/icons/alert-red.svg'}
      />
      <InsuranceCompanyModal
        isOpen={isSetupOpen}
        onClose={() => setIsSetupOpen(false)}
        onSubmit={handleSaveInsuranceSettings}
        insuranceCompany={insuranceCompany}
        settings={settings}
      />
    </div>
  );
};

export default InsuranceRow;
